import {replaceObj} from '@/utils/utils'
export default {
	data () {
		return {
			form: {},
			formHelper: {},
			option: {},
			rules: {},
			api: {},
			detailDialog: {
				visible: false,
				params: {
					id: ''
				}
			}
		}
	},
	props: {
		params: {
      type: Object,
			default: () => {
				return {}
			}
		},
		visible: {
	    type: Boolean,
	    default: false
		}
	},
	computed: {
		title() {
			const matchedKey = this.$route.matched[1] && this.$route.matched[1].meta && this.$route.matched[1].meta.title ? 1 : 0
			return `添加/编辑${this.$route.matched[matchedKey].meta.title}`
		}
	},
	methods: {
		open() {
			this.$nextTick(()=> {
				 // 重置表单
				this.$refs['form'].resetFields()

				// 不存在API直接退出
				const api = this.api[this.params.id || this.params.ids ? 'edit' : 'create']
				if (api === undefined) {
					this.afterOpen()
					return false
				}

				// 加载数据
				api(this.params.id || this.params.ids).then(res=> {
					res.data.option !== undefined && replaceObj(this.option, res.data.option)
					res.data.data !== undefined && replaceObj(this.form, res.data.data)
					res.data.formHelper !== undefined && replaceObj(this.formHelper, res.data.formHelper)
					this.afterOpen(res.data)
				})
			})
		},
		afterOpen() {
		},
		save() {
			const api = this.api[this.form.id || this.form.ids ? 'update' : 'save']
			if (api === undefined) {
				return false
			}

			// 保存数据
			this.$refs['form'].validate(valid=> {
				if (!valid) {
					return false
				}
				api(this.form).then(res=> {
					res.code == 1 ? this.saveSuccess(res.data) : this.saveFail()
				})
			})
		},
		saveFail() {
		},
		beforeClose() {
		},
		saveSuccess() {
			this.$emit('table-reload')
			this.beforeClose()
			this.close()
		},
		close() {
			this.$emit('update:visible', false)
		},
    cellStyle() {
      return {"border-bottom": 0}
    },
    rowStyle() {
      return {"background-color": "#F2F6FC"}
    },
		read(id) {
			this.detailDialog.params.id = id
			this.detailDialog.visible = true
		}
	}
}